import { Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import FilterSelect from "components/MainSelect/MainSelect.view";
import { FiltersDefaultButton } from "pages/Corporate/components/FiltersDefaultButton/FiltersDefaultButton.view";
import { useStyles } from "./OeeSummaryDashboardFilters.styles";
import useOeeSummaryDashboardFilters from "./useOeeSummaryDashboardFilters";

const OeeSummaryDashboardFilters = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const {
        applyFilters,
        filters,
        handleFiltersChange,
        isFiltersDefault,
        isLoading,
        loadingDefaultOperations,
        machineCentersOptions,
        removeDefaultFilters,
        resetFilters,
        setDefaultFilters,
        shiftsOptions,
        userFiltersDefault,
    } = useOeeSummaryDashboardFilters();

    if (isLoading) {
        return (
            <div className={`${classes.mainWrapper} ${classes.mainWrapperLoading}`}>
                <CircularProgress color="info" />
            </div>
        );
    }

    return (
        <div className={classes.mainWrapper}>
            <div className={classes.filtersWrapper}>
                <FilterSelect
                    order="asc"
                    multiple
                    label={t("locations.summary_report.filters.machine_center")}
                    options={machineCentersOptions}
                    value={filters.machineCenter}
                    onChange={({ target: { value } }) =>
                        handleFiltersChange({ machineCenter: typeof value === "string" ? value.split(",") : value })
                    }
                />
                <FilterSelect
                    order="asc"
                    label={t("locations.summary_report.filters.shift")}
                    options={shiftsOptions}
                    value={filters.shift}
                    onChange={({ target: { value } }) => handleFiltersChange({ shift: value })}
                />
            </div>
            <div className={classes.filtersActionsWrapper}>
                <FiltersDefaultButton
                    isSelected={isFiltersDefault}
                    hasDefault={!!userFiltersDefault}
                    handleOperation={isFiltersDefault ? removeDefaultFilters : setDefaultFilters}
                    disabled={loadingDefaultOperations}
                />
                <div className={classes.link} onClick={resetFilters}>
                    {t("locations.summary_report.filters.clear_filters")}
                </div>
                <Button variant="contained" color="info" onClick={applyFilters}>
                    {t("locations.summary_report.filters.apply_filters")}
                </Button>
            </div>
        </div>
    );
};

export default OeeSummaryDashboardFilters;
